import React from 'react';
import { Section } from '../ui/Section';
import { Home, CircleDollarSign, Baby, Flame, Wheat, Leaf } from 'lucide-react';
export function Kits() {
  const kits = [{
    icon: Home,
    name: 'Clásico Hogar',
    desc: 'Recetas tradicionales que le gustan a toda la familia. Horno, hornalla y olla.',
    color: 'bg-amber-50 text-amber-600',
    image: 'https://cdn.magicpatterns.com/uploads/4sEFDKYNj4PV8dGrQiVdbs/Kit_Clasico_Hogar.png'
  }, {
    icon: Baby,
    name: 'Familia / Kids',
    desc: 'Recetas kid-friendly que los chicos realmente comen. Sin dramas.',
    color: 'bg-pink-50 text-pink-600',
    image: 'https://cdn.magicpatterns.com/uploads/diKL5pQ4EumwJ4YawiQyuY/Kit_Familia.png'
  }, {
    icon: CircleDollarSign,
    name: 'Ahorro Inteligente',
    desc: '30 recetas pensadas para rendir más con menos. Comidas completas, económicas y congelables.',
    color: 'bg-blue-50 text-blue-600',
    image: 'https://cdn.magicpatterns.com/uploads/ab4fAirb31rnfBbVSCZjmr/Kit_Ahorro_Inteligente.png'
  }, {
    icon: Flame,
    name: 'Keto / Low Carb',
    desc: 'Separado por gramos de carbohidratos. Ideal para dietas cetogénicas.',
    color: 'bg-orange-50 text-orange-600',
    image: 'https://cdn.magicpatterns.com/uploads/7tkK3JRBvsJdnySY5HRqic/Kit_Low_Carb.png'
  }, {
    icon: Wheat,
    name: 'Sin Gluten',
    desc: '100% libre de gluten. Certificado y delicioso.',
    color: 'bg-yellow-50 text-yellow-700',
    image: 'https://cdn.magicpatterns.com/uploads/wCvZM3Vvtcq7paZxM742Kp/Kit_Sin_Gluten.png'
  }, {
    icon: Leaf,
    name: 'Vegano Freezer-Friendly',
    desc: 'Plant-based completo. Proteína vegetal en cada comida.',
    color: 'bg-green-50 text-green-600',
    image: 'https://cdn.magicpatterns.com/uploads/wX74sgPQ3PnZmN1kJCps31/Kit_Vegano_Freezer.png'
  }];
  return <Section data-id="element-151">
      <div className="text-center mb-6 md:mb-10" data-id="element-152">
        <span className="text-brand-caramel font-semibold text-xs md:text-sm uppercase tracking-wider" style={{
        fontSize: "16px"
      }} data-id="element-153">
          ¿Qué incluye?
        </span>
        <h2 className="text-2xl md:text-4xl font-bold text-brand-slate-900 mt-2 mb-3 md:mb-4" data-id="element-154">
          Conocé cada kit
        </h2>
        <p className="text-sm md:text-base text-brand-slate-600 max-w-xl mx-auto" data-id="element-155">
          Cada kit tiene 30 recetas pensadas para congelar perfecto. El pack
          incluye los 6.
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5" data-id="element-156">
        {kits.map((kit, i) => <div key={i} className="bg-white p-4 md:p-6 rounded-xl md:rounded-2xl border border-brand-slate-200 hover:border-brand-sky/50 hover:shadow-lg hover:shadow-brand-sky/5 transition-all" data-id="element-157">
            {kit.image ? <div className="mb-3 md:mb-4 -mx-4 -mt-4 md:-mx-6 md:-mt-6" data-id="element-158">
                <img src={kit.image} alt={`Portada ${kit.name}`} className="w-full h-32 md:h-40 object-cover rounded-t-xl md:rounded-t-2xl" data-id="element-159" />
              </div> : <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl ${kit.color} flex items-center justify-center mb-3 md:mb-4`} data-id="element-160">
                <kit.icon className="w-5 h-5 md:w-6 md:h-6" data-id="element-161" />
              </div>}
            <h3 className="text-sm md:text-lg font-semibold text-brand-slate-900 mb-1 md:mb-2" data-id="element-162">
              {kit.name}
            </h3>
            <p className="text-brand-slate-600 text-xs md:text-sm leading-relaxed" data-id="element-163">
              {kit.desc}
            </p>
            <div className="mt-3 md:mt-4 pt-3 md:pt-4 border-t border-brand-slate-100" data-id="element-164">
              <span className="text-[10px] md:text-xs font-medium text-brand-slate-400" data-id="element-165">
                30 recetas incluidas
              </span>
            </div>
          </div>)}
      </div>
    </Section>;
}